/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function PaginationNextIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 -1 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_2112_551" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_2112_551)">
        <path d="M13.8558 10.625H4.375C4.19765 10.625 4.04915 10.5651 3.9295 10.4455C3.80983 10.3258 3.75 10.1773 3.75 9.99998C3.75 9.82264 3.80983 9.67414 3.9295 9.55448C4.04915 9.43483 4.19765 9.37501 4.375 9.37501H13.8558L9.54806 5.0673C9.42413 4.94337 9.36297 4.79834 9.36458 4.63221C9.36618 4.46607 9.43162 4.31837 9.5609 4.18911C9.69016 4.06839 9.83652 4.00589 9.99998 4.00161C10.1634 3.99733 10.3098 4.05983 10.4391 4.18911L15.7227 9.47275C15.8007 9.55074 15.8557 9.63301 15.8878 9.71955C15.9198 9.80607 15.9359 9.89955 15.9359 9.99998C15.9359 10.1004 15.9198 10.1939 15.8878 10.2804C15.8557 10.367 15.8007 10.4492 15.7227 10.5272L10.4391 15.8109C10.3237 15.9262 10.1808 15.9853 10.0104 15.9879C9.83999 15.9906 9.69016 15.9316 9.5609 15.8109C9.43162 15.6816 9.36698 15.5331 9.36698 15.3654C9.36698 15.1976 9.43162 15.0491 9.5609 14.9199L13.8558 10.625Z" fill="currentColor" />
      </g>
    </svg>
  );
}

export default PaginationNextIcon;
